import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { listInvoiceSettings } from "../../graphql";
import { PURGE } from "redux-persist";

export const fetchInvoiceSettings = createAsyncThunk(
  "invoiceSettings/fetchSettings",
  async () => {
    const response = await API.graphql(
      graphqlOperation(listInvoiceSettings, { type: "ALL" })
    );
    return response.data.listInvoiceSettings;
    // Pos: response.data.listInvoiceSettings.find((elem) => elem.TypeCD === 'PosSettings')
  }
);

const INITIAL_STATE = {
  Loaded: false,
};

const invoiceSettingsSlice = createSlice({
  name: "invoiceSettings",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceSettings.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchInvoiceSettings.fulfilled, (state, action) => {
        return {
          Loaded: true,
          Pos: action?.payload?.find((elem) => elem.TypeCD === "PosSettings"),
          Regular: action?.payload?.find(
            (elem) => elem.TypeCD === "RegularSettings"
          ),
        };
        // return {
        //     ...action?.payload?.data,
        //     Loaded: true,
        // };
      })
      .addCase(fetchInvoiceSettings.rejected, (state) => {
        state.Loaded = false;
      })
      .addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});
export const {} = invoiceSettingsSlice.actions;
export default invoiceSettingsSlice.reducer;
